module.exports = __webpack_public_path__ + "static/media/iconEvaluation.22670b47.svg";